import { useMediaQuery } from '@mui/material'
import { useQueryClient } from 'react-query'
import Input from 'components/Input/Input'
import Modal from 'components/Modal/Modal'
import { Form, Formik } from 'formik'
import { usePostOrderNote } from 'hooks/useOrders'
import { t } from 'i18next'
import theme from 'lib/theme'
import { useAlert } from 'providers/AlertProvider'

type AddNoteModalType = {
  modal: { right: boolean }
  handleCloseModal: () => void
  orderId: string
  partId: string
  crc: string
}

export const AddNoteModal = ({
  modal,
  handleCloseModal,
  orderId,
  partId,
  crc,
}: AddNoteModalType) => {
  const { setAlert } = useAlert()
  const queryClient = useQueryClient()
  const { mutateAsync, isLoading: isLoadingRequest } = usePostOrderNote(
    orderId as string,
    partId as string
  )
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const initialValues = {
    note: '',
  }

  const handleSubmit = async (values: { note: string }) => {
    const note = {
      message: values.note,
      crc,
    }
    await mutateAsync(note, {
      onSuccess: () => {
        handleCloseModal()
        setAlert(t('saved'), 'success', {
          vertical: 'bottom',
          horizontal: isMobile ? 'center' : 'left',
        })
        queryClient.refetchQueries(['getOrderInfo', orderId])
        queryClient.refetchQueries(['getOrderEvents', orderId + partId])
      },
      onError: () => {
        setAlert(t('failureMessage'), 'failure', {
          vertical: 'bottom',
          horizontal: isMobile ? 'center' : 'right',
        })
      },
    })
  }
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={async (values) => handleSubmit(values)}>
      {({ isValid, dirty, submitForm }) => (
        <Modal
          showButton
          buttonIsDisabled={!isValid || !dirty}
          onButtonClick={submitForm}
          isLoadingRequest={isLoadingRequest}
          setModal={handleCloseModal}
          buttonText={t('save')}
          modal={modal}
          title={t('addNote')}>
          <Form
            style={{
              width: '100%',
            }}>
            <Input
              label={t('note')}
              name='note'
              type='text'
              variant='filled'
              fullWidth
              multiline
              rows={7}
            />
          </Form>
        </Modal>
      )}
    </Formik>
  )
}
